import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../../../components/Icon';

import styles from './shareSocial.module.css';

export default class ShareSocialButtons extends React.PureComponent {
  static meta(prop) {
    const meta = document.querySelector(`meta[property="${prop}"]`);

    return meta ? meta.getAttribute('content') : null;
  }

  static get url() {
    return encodeURIComponent(
      ShareSocialButtons.meta('og:url') || window.location.href,
    );
  }

  static get title() {
    return encodeURIComponent(
      `${ShareSocialButtons.meta('og:title') || document.title} ${
        window.HOTEL_DATA.HOTEL.stars
      }*`,
    );
  }

  static get image() {
    return encodeURIComponent(ShareSocialButtons.meta('og:image'));
  }

  shareButtonsConfig = {
    vk: {
      label: 'Вконтакте',
      color: '#4c75a3',
      width: 23,
      url: 'https://vk.com/share.php',
      fn() {
        return [
          `url=${ShareSocialButtons.url}`,
          `title=${ShareSocialButtons.title}`,
          `description=${this.description}`,
          `image=${ShareSocialButtons.image}`,
          'noparse=true',
        ].join('&');
      },
    },
    fb: {
      label: 'Facebook',
      color: '#445281',
      width: 12,
      type: 'api',
      url: 'https://www.facebook.com/sharer/sharer.php',
      fn: () => {
        window.FB.ui({
          method: 'share',
          href: decodeURIComponent(ShareSocialButtons.url),
          title: decodeURIComponent(ShareSocialButtons.title),
          image: decodeURIComponent(ShareSocialButtons.image),
          quote: decodeURIComponent(this.description),
        });
      },
    },
    // TODO: проверить актуальность
    // tw: {
    //   title: (
    //     <span className="social-label">
    //       <span className="social-icon">
    //         <SvgIcon name="twitter" size="20" viewBox="0 0 40 40" />
    //       </span>
    //       Twitter
    //     </span>
    //   ),
    //   url: 'http://twitter.com/share',
    //   fn() {
    //     return [
    //       `text=${this.description}`,
    //       `url=${ShareSocialButtons.url}`,
    //       `counturl=${ShareSocialButtons.url}`,
    //       `image=${ShareSocialButtons.image}`,
    //     ].join('&');
    //   },
    // },
    // gp: {
    //   title: (
    //     <span className="social-label">
    //       <span className="social-icon">
    //         <SvgIcon name="google_plus" size="20" viewBox="0 0 40 40" />
    //       </span>
    //       Google+
    //     </span>
    //   ),
    //   url: 'https://plus.google.com/share',
    //   fn() {
    //     return [
    //       `url=${ShareSocialButtons.url}`,
    //       `t=${ShareSocialButtons.title}`,
    //       `comment=${this.description}`,
    //     ].join('&');
    //   },
    // },
    // ok: {
    //   title: 'Одноклассники',
    //   fn() { },
    // },
  };

  handleShare(providerObj) {
    if (providerObj.type !== 'api') {
      const { url } = providerObj;
      const params = providerObj.fn.call(this);

      if (url && params) {
        const win = window.open(
          'about:blank',
          '',
          'toolbar=0,status=0,width=626,height=436',
        );
        win.location.href = `${url}?${params}`;
        win.focus();
      }
    } else {
      providerObj.fn.call(this);
    }
  }

  get description() {
    const { description } = this.props;
    return description;
  }

  render() {
    const { networks = Object.keys(this.shareButtonsConfig) } = this.props;

    return (
      <ul>
        {networks.map((name) => {
          const item = this.shareButtonsConfig[name];
          const { label, color, width } = item;
          return (
            <li className={styles.item} key={name}>
              <button
                type="button"
                className={styles.button}
                onClick={() => this.handleShare(item)}
              >
                <span className={styles.iconContainer}>
                  <Icon
                    className={styles.icon}
                    type={`social-${name}`}
                    style={{ '--color': color }}
                    width={width}
                  />
                </span>
                <span>{label}</span>
              </button>
            </li>
          );
        })}
      </ul>
    );
  }
}

ShareSocialButtons.defaultProps = {
  networks: null,
  description: '',
};

ShareSocialButtons.propTypes = {
  networks: PropTypes.arrayOf(PropTypes.string),
  description: PropTypes.string,
};
